import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import { cls, Column, Grid, Row } from '../../packages/components';
import ResumenEvent from '../EventOptions/components/ResumenEvent';

let eventData = {};

export const setEventData = (data) => {
    eventData = data;
}

export const getEventData = () => (eventData || {});


const ModalTimeOutEvent = (props) => {
    const asset = props.asset || false;
    const title = props.contentTitleNormal || false;
    const content = props.content || false;
    let buttons = [];
    const callback = props.callback || false;
    const withCancel = props.withCancel || false;

    if (withCancel) {
        const buttonCancel = Translator.get('modal_default_cancel', 'Cancelar');
        buttons.push({
            content: buttonCancel,
            props: {
                onClick: (e) => props.handleClose(e, callback),
            }
        });
    }

    if (props.buttons) {
        const tmp = props.buttons.map(button => {
            const newButton = Object.assign({}, button);
            const cb = newButton.props.onClick;
            newButton.props.onClick = (e) => {
                props.handleClose(e, cb);
            };
            return newButton;
        });
        buttons = [...buttons, ...tmp];
    }

    const p = {
        buttons
    };

    if(props.closeTime){
        setTimeout(()=>{
            props.handleClose(null,props.closeTime.cb)
        },props.closeTime.time);
    }


    if (asset) p['asset'] = asset;
    if (title) p['title'] = title;
    if (content) p['content'] = content;
    if(props.showResume){
        const modalProps = {
            childrenClassName: 'modal_full_height_options_event',
            buttons,
            callbackWhenBack: props.callbackWhenBack
        }
        const data = {...getEventData()};

        return (
            <ModalWrapper {...modalProps}>
                <Grid className={cls(`aaf-main-modal-options-event`,`aaf-main-modal-options-event-resume`)}>
                    <Row className={cls(`aaf-main-modal-options-row`)}>
                        <Column lg={8} className={cls(`aaf-main-modal-options-col-left`)}>
                            <ResumenEvent event={data}/>
                        </Column>
                    </Row>
                </Grid>
            </ModalWrapper>
        );
    }

    return <ModalWrapper {...p} />;
}

export const ModalTimeOutEventWithOnClose = withOnClose(ModalTimeOutEvent);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalTimeOutEvent.jsx